import { render } from "./ContactIndustrialClientsView.vue?vue&type=template&id=84cd6582"
import script from "./ContactIndustrialClientsView.vue?vue&type=script&lang=js"
export * from "./ContactIndustrialClientsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__